import { render, staticRenderFns } from "./loginAccountDetails.vue?vue&type=template&id=6de7c39c&scoped=true&"
import script from "./loginAccountDetails.vue?vue&type=script&lang=js&"
export * from "./loginAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de7c39c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
